<ng-template #pageResultTemplate let-item>
	<div>
		<div class="whitespace-nowrap truncate">
			{{ item.pageName }}
		</div>
		<div>
			<span class="text-xs text-grey">{{ item.match }}</span>
		</div>
	</div>
</ng-template>

<ng-template #contactResultTemplate let-item>
	<div>
		<div class="whitespace-nowrap truncate">
			{{ item.name }}
		</div>
		<div>
			<span class="text-xs text-grey">{{ item.association }}</span>
		</div>
	</div>
</ng-template>

<app-auto-complete
	(onSelect)="onSelect($event)"
	(debounce)="onSearch($event)"
	placeholder="Search this matter"
	[itemGroups]="[
		{
			items: pageResults,
			template: pageResultTemplate,
			type: selectOptions.PAGE,
		},
		{
			items: contactSearchResults,
			title: 'Contacts',
			template: contactResultTemplate,
			type: selectOptions.CONTACT,
		},
	]"
	name="matter-search"
	minSearchTerm="2"
	id="nav-matter-search"
	intercomAttr="matter-search"
	[testHook]="testHooks.MatterSearchAutoComplete"
>
</app-auto-complete>
